import { DigestateJob, DigestateJobFormCreate, DigestateJobScheduleForm } from '@/models'
import type { TDigestateJobsState } from '@/types/state-types'

export default <TDigestateJobsState>{
  jobForm: new DigestateJobFormCreate(),
  scheduledJobForm: new DigestateJobScheduleForm(),
  digestateJobDetails: new DigestateJob(),
  isDigestateFormLoading: false,
  isDigestateFormButtonLoading: false
}
